import { render, staticRenderFns } from "./BeaconMap.vue?vue&type=template&id=04c6ce95&scoped=true&"
import script from "./BeaconMap.vue?vue&type=script&lang=js&"
export * from "./BeaconMap.vue?vue&type=script&lang=js&"
import style0 from "./BeaconMap.vue?vue&type=style&index=0&id=04c6ce95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c6ce95",
  null
  
)

export default component.exports